import React, {

    useEffect,

    useRef,

    useState

}

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../../constants/colors";

import ImageComposerCanvas

from "./ImageComposerCanvas";









//========================================================
// Image Composer Drawer
//
// Nigel's Image Mangle.
//
// Provides a workspace for combining multiple source images
// into a single derived image.
//
// The composer operates on basket image items rather than
// directly on document snippets. This allows source images
// and, later, derived images to use the same workflow.
//
// The drawer maintains its own working copy of the selected
// source images. Removing an image here only removes it from
// the current composition. It does not alter the Document
// Basket or the original source content.
//
// When Add Merged Image is selected, the Image Composer
// Canvas renders the current composition into a genuine PNG
// Blob. The Blob and the source provenance are then passed
// back to the Document Builder.
//========================================================

export default function ImageComposerDrawer({

    visible,

    images = [],

    onClose,

    onAddMergedImage

})

{

    //========================================================
    // Canvas Reference
    //========================================================

    const composerCanvasRef =

        useRef(null);









    //========================================================
    // Layout Mode
    //========================================================

    const [

        layoutMode,

        setLayoutMode

    ] = useState(

        "SOURCE"

    );









    //========================================================
    // Composition Images
    //========================================================

    const [

        compositionImages,

        setCompositionImages

    ] = useState([]);









    //========================================================
    // Rendering
    //========================================================

    const [

        rendering,

        setRendering

    ] = useState(false);









    //========================================================
    // Render Error
    //========================================================

    const [

        renderError,

        setRenderError

    ] = useState(null);









    //========================================================
    // Reset When Opened
    //========================================================

    useEffect(

        () =>

        {

            if (

                visible

            )

            {

                //================================================
                // Default Layout
                //================================================

                setLayoutMode(

                    "SOURCE"

                );


                //================================================
                // Working Copy Of Source Images
                //================================================

                setCompositionImages(

                    Array.isArray(images)

                        ?

                        [...images]

                        :

                        []

                );


                //================================================
                // Rendering State
                //================================================

                setRendering(

                    false

                );


                setRenderError(

                    null

                );

            }

        },

        [

            visible,

            images

        ]

    );









    //========================================================
    // Close
    //========================================================

    const handleClose = () =>

    {

        if (

            rendering

        )

        {

            return;

        }


        if (

            onClose

        )

        {

            onClose();

        }

    };









    //========================================================
    // Remove Image
    //
    // Removes an image from Nigel's current composition only.
    //
    // The original basket item remains untouched.
    //========================================================

    const handleRemoveImage = (

        image,

        index

    ) =>

    {

        const imageKey =

            getImageKey(

                image,

                index

            );


        setCompositionImages(

            current =>

                current.filter(

                    (currentImage, currentIndex) =>

                        getImageKey(

                            currentImage,

                            currentIndex

                        ) !== imageKey

                )

        );


        setRenderError(

            null

        );

    };









    //========================================================
    // Add Merged Image
    //
    // Requests a genuine PNG from the Image Composer Canvas
    // and passes both the rendered image and its complete
    // source recipe back to the Document Builder.
    //========================================================

    const handleAddMergedImage = async () =>

    {

        //====================================================
        // Already Rendering
        //====================================================

        if (

            rendering

        )

        {

            return;

        }


        //====================================================
        // Need At Least Two Images
        //====================================================

        if (

            compositionImages.length < 2

        )

        {

            return;

        }


        //====================================================
        // Canvas Available
        //====================================================

        if (

            !composerCanvasRef.current ||

            !composerCanvasRef.current.renderComposition

        )

        {

            setRenderError(

                "The image composition is not ready."

            );


            return;

        }


        //====================================================
        // Start
        //====================================================

        setRendering(

            true

        );


        setRenderError(

            null

        );


        try

        {

            //================================================
            // Render PNG
            //================================================

            const blob =

                await composerCanvasRef.current.renderComposition();


            //================================================
            // Render Failed
            //================================================

            if (

                !blob

            )

            {

                setRenderError(

                    "Unable to create the merged image."

                );


                return;

            }


            //================================================
            // Derived Basket ID
            //================================================

            const basketId =

                createDerivedBasketId();


            //================================================
            // Composition
            //
            // Keep both the actual rendered image and the
            // complete source recipe.
            //================================================

            const composition =

            {

                basketId:

                    basketId,

                basketContentType:

                    "DERIVED_IMAGE",

                source:

                    "IMAGE_COMPOSER",

                contentType:

                    "image/png",

                layoutMode:

                    layoutMode,

                blob:

                    blob,

                sources:

                    compositionImages.map(

                        image =>

                        ({

                            basketId:

                                image?.basketId,

                            documentId:

                                image?.documentId,

                            documentSharepointId:

                                image?.documentSharepointId,

                            documentTitle:

                                image?.documentTitle,

                            documentSnippetId:

                                image?.documentSnippetId,

                            documentSnippetSectionId:

                                image?.documentSnippetSectionId,

                            pageNumber:

                                image?.pageNumber,

                            sectionSequence:

                                image?.sectionSequence,

                            sectionType:

                                image?.sectionType,

                            contentType:

                                image?.contentType,

                            x:

                                image?.x,

                            y:

                                image?.y,

                            width:

                                image?.width,

                            height:

                                image?.height

                        })

                    )

            };


            //================================================
            // Display Metadata
            //================================================

            const firstSource =

                compositionImages[0];


            composition.documentTitle =

                "Merged Image";


            composition.pageNumber =

                firstSource?.pageNumber;


            composition.sourceDocumentTitle =

                firstSource?.documentTitle;


            composition.sourceCount =

                compositionImages.length;


            //================================================
            // Debug
            //================================================

            console.log(

                "Nigel has genuinely mangled",

                composition

            );


            //================================================
            // Callback
            //================================================

            if (

                onAddMergedImage

            )

            {

                await onAddMergedImage(

                    composition

                );

            }


            //================================================
            // Close
            //================================================

            if (

                onClose

            )

            {

                onClose();

            }

        }

        catch (

            error

        )

        {

            console.error(

                "Nigel's mangle malfunctioned",

                error

            );


            setRenderError(

                "Unable to create the merged image."

            );

        }

        finally

        {

            setRendering(

                false

            );

        }

    };









    //========================================================
    // Not Visible
    //========================================================

    if (

        !visible

    )

    {

        return null;

    }









    //========================================================
    // Can Merge
    //========================================================

    const canMerge =

        compositionImages.length >= 2 &&

        !rendering;









    //========================================================
    // Render
    //========================================================

    return (

        <div style={styles.backdrop}>



            {/*============================================
                Drawer
            ============================================*/}

            <div style={styles.drawer}>



                {/*========================================
                    Header
                ========================================*/}

                <div style={styles.header}>

                    <div style={styles.headerTitleContainer}>

                        <div style={styles.eyebrow}>

                            IMAGE COMPOSER

                        </div>


                        <div style={styles.title}>

                            Combine Source Images

                        </div>


                        <div style={styles.subtitle}>

                            Arrange {

                                compositionImages.length

                            } selected {

                                compositionImages.length === 1

                                    ?

                                    "image"

                                    :

                                    "images"

                            } into a single composed image.

                        </div>

                    </div>


                    <button

                        type="button"

                        style={styles.closeButton}

                        onClick={

                            handleClose

                        }

                    >

                        ×

                    </button>

                </div>









                {/*========================================
                    Toolbar
                ========================================*/}

                <div style={styles.toolbar}>

                    <div style={styles.toolbarLabel}>

                        LAYOUT

                    </div>


                    <div style={styles.layoutButtons}>

                        <LayoutButton

                            label="Source Layout"

                            active={

                                layoutMode ===
                                "SOURCE"

                            }

                            disabled={

                                rendering

                            }

                            onClick={

                                () =>
                                    setLayoutMode(

                                        "SOURCE"

                                    )

                            }

                        />


                        <LayoutButton

                            label="Horizontal"

                            active={

                                layoutMode ===
                                "HORIZONTAL"

                            }

                            disabled={

                                rendering

                            }

                            onClick={

                                () =>
                                    setLayoutMode(

                                        "HORIZONTAL"

                                    )

                            }

                        />


                        <LayoutButton

                            label="Vertical"

                            active={

                                layoutMode ===
                                "VERTICAL"

                            }

                            disabled={

                                rendering

                            }

                            onClick={

                                () =>
                                    setLayoutMode(

                                        "VERTICAL"

                                    )

                            }

                        />


                        <LayoutButton

                            label="Grid"

                            active={

                                layoutMode ===
                                "GRID"

                            }

                            disabled={

                                rendering

                            }

                            onClick={

                                () =>
                                    setLayoutMode(

                                        "GRID"

                                    )

                            }

                        />

                    </div>


                    <div style={styles.toolbarCount}>

                        <span style={styles.toolbarCountNumber}>

                            {

                                compositionImages.length

                            }

                        </span>

                        {

                            compositionImages.length === 1

                                ?

                                "source image"

                                :

                                "source images"

                        }

                    </div>

                </div>









                {/*========================================
                    Workspace
                ========================================*/}

                <div style={styles.workspace}>

                    <div style={styles.workspaceInner}>



                        {/*================================
                            Canvas Header
                        ================================*/}

                        <div style={styles.canvasHeader}>

                            <div>

                                <div style={styles.canvasEyebrow}>

                                    COMPOSITION PREVIEW

                                </div>


                                <div style={styles.canvasTitle}>

                                    {

                                        layoutMode === "SOURCE"

                                            ?

                                            "Source Layout"

                                            :

                                            layoutMode === "HORIZONTAL"

                                                ?

                                                "Horizontal Layout"

                                                :

                                                layoutMode === "VERTICAL"

                                                    ?

                                                    "Vertical Layout"

                                                    :

                                                    "Grid Layout"

                                    }

                                </div>

                            </div>


                            <div style={styles.canvasMeta}>

                                {

                                    compositionImages.length

                                } {

                                    compositionImages.length === 1

                                        ?

                                        "image"

                                        :

                                        "images"

                                }

                            </div>

                        </div>









                        {/*================================
                            Composition Canvas
                        ================================*/}

                        <div style={styles.canvas}>

                            <ImageComposerCanvas

                                ref={

                                    composerCanvasRef

                                }

                                images={

                                    compositionImages

                                }

                                layoutMode={

                                    layoutMode

                                }

                            />

                        </div>

                    </div>

                </div>









                {/*========================================
                    Source Strip
                ========================================*/}

                <div style={styles.sourceStrip}>

                    <div style={styles.sourceStripHeader}>

                        <div style={styles.sourceStripLabel}>

                            SELECTED SOURCES

                        </div>


                        <div style={styles.sourceStripHint}>

                            Remove unwanted image fragments
                            from this composition

                        </div>

                    </div>


                    <div style={styles.sourceItems}>

                        {

                            compositionImages.map(

                                (image, index) =>

                                    <div

                                        key={

                                            getImageKey(

                                                image,

                                                index

                                            )

                                        }

                                        style={styles.sourceItem}

                                    >

                                        {/*====================
                                            Number
                                        ====================*/}

                                        <div style={styles.sourceNumber}>

                                            {

                                                String(

                                                    index + 1

                                                ).padStart(

                                                    2,

                                                    "0"

                                                )

                                            }

                                        </div>





                                        {/*====================
                                            Details
                                        ====================*/}

                                        <div style={styles.sourceDetails}>

                                            <div style={styles.sourceTitle}>

                                                {

                                                    image?.documentTitle ||
                                                    "Source Image"

                                                }

                                            </div>


                                            <div style={styles.sourceMeta}>

                                                {

                                                    image?.pageNumber != null

                                                        ?

                                                        "Page " +
                                                        image.pageNumber

                                                        :

                                                        "Source page"

                                                }


                                                {

                                                    image?.sectionSequence != null &&

                                                    (

                                                        <>

                                                            <span style={styles.separator}>

                                                                ·

                                                            </span>

                                                            Section {

                                                                image.sectionSequence

                                                            }

                                                        </>

                                                    )

                                                }

                                            </div>

                                        </div>





                                        {/*====================
                                            Remove
                                        ====================*/}

                                        <button

                                            type="button"

                                            title="Remove from composition"

                                            disabled={

                                                rendering

                                            }

                                            style={

                                                {

                                                    ...styles.sourceRemove,

                                                    ...(rendering

                                                        ?

                                                        styles.sourceRemoveDisabled

                                                        :

                                                        {})

                                                }

                                            }

                                            onClick={

                                                () =>
                                                    handleRemoveImage(

                                                        image,

                                                        index

                                                    )

                                            }

                                        >

                                            ×

                                        </button>

                                    </div>

                            )

                        }


                        {/*================================
                            No Sources
                        ================================*/}

                        {

                            compositionImages.length === 0 &&

                            (

                                <div style={styles.noSources}>

                                    No source images remain in
                                    this composition.

                                </div>

                            )

                        }

                    </div>

                </div>









                {/*========================================
                    Footer
                ========================================*/}

                <div style={styles.footer}>

                    <div>

                        <div style={styles.footerHint}>

                            {

                                rendering

                                    ?

                                    "Creating merged image..."

                                    :

                                    canMerge

                                        ?

                                        "The original source images remain unchanged."

                                        :

                                        "At least two images are required to create a merged image."

                            }

                        </div>


                        {

                            renderError &&

                            (

                                <div style={styles.footerError}>

                                    {

                                        renderError

                                    }

                                </div>

                            )

                        }

                    </div>


                    <div style={styles.footerActions}>

                        <button

                            type="button"

                            disabled={

                                rendering

                            }

                            style={

                                {

                                    ...styles.cancelButton,

                                    ...(rendering

                                        ?

                                        styles.cancelButtonDisabled

                                        :

                                        {})

                                }

                            }

                            onClick={

                                handleClose

                            }

                        >

                            Cancel

                        </button>


                        <button

                            type="button"

                            disabled={

                                !canMerge

                            }

                            style={

                                {

                                    ...styles.addButton,

                                    ...(!canMerge

                                        ?

                                        styles.addButtonDisabled

                                        :

                                        {})

                                }

                            }

                            onClick={

                                handleAddMergedImage

                            }

                        >

                            <span>

                                {

                                    rendering

                                        ?

                                        "Composing..."

                                        :

                                        "Add Merged Image"

                                }

                            </span>


                            {

                                !rendering &&

                                (

                                    <span style={styles.addArrow}>

                                        →

                                    </span>

                                )

                            }

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}









//========================================================
// Layout Button
//========================================================

function LayoutButton({

    label,

    active,

    disabled,

    onClick

})

{

    return (

        <button

            type="button"

            disabled={

                disabled

            }

            style={

                {

                    ...styles.layoutButton,

                    ...(active

                        ?

                        styles.layoutButtonActive

                        :

                        {}),

                    ...(disabled

                        ?

                        styles.layoutButtonDisabled

                        :

                        {})

                }

            }

            onClick={

                onClick

            }

        >

            {label}

        </button>

    );

}









//========================================================
// Derived Basket ID
//========================================================

function createDerivedBasketId()

{

    return (

        "derived-image-" +

        Date.now() +

        "-" +

        Math.random()

            .toString(36)

            .substring(

                2,

                9

            )

    );

}









//========================================================
// Image Key
//========================================================

function getImageKey(

    image,

    index

)

{

    return (

        image?.basketId ||

        image?.documentSnippetSectionId ||

        "image-" +
        index

    );

}









//========================================================
// Styles
//========================================================

const styles =

{

    //========================================================
    // Backdrop
    //========================================================

    backdrop:

    {

        position:

            "fixed",

        top:

            0,

        right:

            0,

        bottom:

            0,

        left:

            0,

        display:

            "flex",

        justifyContent:

            "flex-end",

        background:

            "rgba(7,18,26,0.46)",

        backdropFilter:

            "blur(1px)",

        zIndex:

            4500

    },





    //========================================================
    // Drawer
    //========================================================

    drawer:

    {

        width:

            920,

        maxWidth:

            "92vw",

        height:

            "100%",

        display:

            "flex",

        flexDirection:

            "column",

        background:

            "#f3f6f8",

        boxShadow:

            "-20px 0 60px rgba(0,0,0,0.24)",

        overflow:

            "hidden",

        zIndex:

            20000,

        position:

            "fixed"

    },





    //========================================================
    // Header
    //========================================================

    header:

    {

        minHeight:

            92,

        padding:

            "0 28px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        gap:

            20,

        boxSizing:

            "border-box",

        background:

            "linear-gradient(90deg, #142431 0%, #0d1b26 100%)",

        borderBottom:

            "1px solid rgba(255,255,255,0.07)"

    },

    headerTitleContainer:

    {

        minWidth:

            0

    },

    eyebrow:

    {

        marginBottom:

            5,

        color:

            OMNISCAN_BLUE,

        fontSize:

            9,

        fontWeight:

            700,

        letterSpacing:

            1.4

    },

    title:

    {

        marginBottom:

            4,

        color:

            "#ffffff",

        fontSize:

            18,

        fontWeight:

            600

    },

    subtitle:

    {

        color:

            "rgba(255,255,255,0.42)",

        fontSize:

            10,

        lineHeight:

            1.4

    },

    closeButton:

    {

        width:

            36,

        height:

            36,

        minWidth:

            36,

        padding:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px solid rgba(255,255,255,0.10)",

        borderRadius:

            5,

        background:

            "rgba(255,255,255,0.05)",

        color:

            "rgba(255,255,255,0.72)",

        fontSize:

            23,

        fontWeight:

            300,

        cursor:

            "pointer"

    },





    //========================================================
    // Toolbar
    //========================================================

    toolbar:

    {

        minHeight:

            66,

        padding:

            "0 26px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            18,

        boxSizing:

            "border-box",

        background:

            "#ffffff",

        borderBottom:

            "1px solid #dde4e8"

    },

    toolbarLabel:

    {

        color:

            "#84929d",

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.2

    },

    layoutButtons:

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            6

    },

    layoutButton:

    {

        height:

            32,

        padding:

            "0 12px",

        border:

            "1px solid #d9e1e6",

        borderRadius:

            4,

        background:

            "#ffffff",

        color:

            "#62717c",

        fontSize:

            9,

        fontWeight:

            600,

        cursor:

            "pointer"

    },

    layoutButtonActive:

    {

        border:

            "1px solid rgba(32,175,232,0.55)",

        background:

            "rgba(32,175,232,0.08)",

        color:

            OMNISCAN_BLUE

    },

    layoutButtonDisabled:

    {

        opacity:

            0.55,

        cursor:

            "not-allowed"

    },

    toolbarCount:

    {

        marginLeft:

            "auto",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            6,

        color:

            "#8b99a3",

        fontSize:

            9

    },

    toolbarCountNumber:

    {

        width:

            24,

        height:

            24,

        display:

            "inline-flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        borderRadius:

            4,

        background:

            "rgba(32,175,232,0.10)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            9,

        fontWeight:

            700

    },





    //========================================================
    // Workspace
    //========================================================

    workspace:

    {

        flex:

            1,

        minHeight:

            0,

        padding:

            24,

        boxSizing:

            "border-box",

        overflow:

            "auto"

    },

    workspaceInner:

    {

        minHeight:

            "100%",

        display:

            "flex",

        flexDirection:

            "column"

    },

    canvasHeader:

    {

        minHeight:

            44,

        marginBottom:

            10,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between"

    },

    canvasEyebrow:

    {

        marginBottom:

            3,

        color:

            OMNISCAN_BLUE,

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.1

    },

    canvasTitle:

    {

        color:

            "#263746",

        fontSize:

            14,

        fontWeight:

            600

    },

    canvasMeta:

    {

        color:

            "#9aa6ae",

        fontSize:

            9

    },





    //========================================================
    // Canvas
    //========================================================

    canvas:

    {

        flex:

            1,

        minHeight:

            380,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        border:

            "1px solid #d8e0e5",

        borderRadius:

            6,

        background:

            "#ffffff",

        boxShadow:

            "0 8px 28px rgba(32,50,64,0.08)",

        overflow:

            "hidden"

    },





    //========================================================
    // Source Strip
    //========================================================

    sourceStrip:

    {

        minHeight:

            92,

        padding:

            "12px 24px",

        boxSizing:

            "border-box",

        background:

            "#e9eef1",

        borderTop:

            "1px solid #d8e0e5"

    },

    sourceStripHeader:

    {

        marginBottom:

            8,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        gap:

            20

    },

    sourceStripLabel:

    {

        color:

            "#84939d",

        fontSize:

            8,

        fontWeight:

            700,

        letterSpacing:

            1.1

    },

    sourceStripHint:

    {

        color:

            "#9ca8b0",

        fontSize:

            8

    },

    sourceItems:

    {

        display:

            "flex",

        gap:

            8,

        overflowX:

            "auto",

        overflowY:

            "hidden"

    },

    sourceItem:

    {

        minWidth:

            210,

        maxWidth:

            250,

        height:

            48,

        padding:

            "0 7px 0 10px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            9,

        boxSizing:

            "border-box",

        border:

            "1px solid #d4dde2",

        borderRadius:

            4,

        background:

            "#ffffff"

    },

    sourceNumber:

    {

        width:

            25,

        height:

            25,

        minWidth:

            25,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        borderRadius:

            4,

        background:

            "rgba(32,175,232,0.08)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            8,

        fontWeight:

            700

    },

    sourceDetails:

    {

        flex:

            1,

        minWidth:

            0

    },

    sourceTitle:

    {

        marginBottom:

            3,

        overflow:

            "hidden",

        textOverflow:

            "ellipsis",

        whiteSpace:

            "nowrap",

        color:

            "#52636f",

        fontSize:

            9,

        fontWeight:

            600

    },

    sourceMeta:

    {

        color:

            "#9aa5ad",

        fontSize:

            8

    },

    separator:

    {

        margin:

            "0 5px",

        color:

            "#c2cbd1"

    },





    //========================================================
    // Remove Source
    //========================================================

    sourceRemove:

    {

        width:

            24,

        height:

            24,

        minWidth:

            24,

        padding:

            0,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        boxSizing:

            "border-box",

        border:

            "1px solid #dce3e7",

        borderRadius:

            4,

        background:

            "#f8fafb",

        color:

            "#8b99a3",

        fontSize:

            15,

        fontWeight:

            400,

        lineHeight:

            1,

        cursor:

            "pointer"

    },

    sourceRemoveDisabled:

    {

        opacity:

            0.5,

        cursor:

            "not-allowed"

    },

    noSources:

    {

        width:

            "100%",

        height:

            48,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px dashed #ccd6dc",

        borderRadius:

            4,

        color:

            "#9ba7af",

        fontSize:

            9

    },





    //========================================================
    // Footer
    //========================================================

    footer:

    {

        height:

            70,

        minHeight:

            70,

        padding:

            "0 24px",

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        gap:

            20,

        boxSizing:

            "border-box",

        background:

            "#ffffff",

        borderTop:

            "1px solid #dce3e7"

    },

    footerHint:

    {

        color:

            "#9aa6ae",

        fontSize:

            9

    },

    footerError:

    {

        marginTop:

            4,

        color:

            "#c45454",

        fontSize:

            9,

        fontWeight:

            600

    },

    footerActions:

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            8

    },

    cancelButton:

    {

        height:

            36,

        padding:

            "0 16px",

        border:

            "1px solid #d7dfe4",

        borderRadius:

            4,

        background:

            "#ffffff",

        color:

            "#657681",

        fontSize:

            9,

        fontWeight:

            600,

        cursor:

            "pointer"

    },

    cancelButtonDisabled:

    {

        opacity:

            0.55,

        cursor:

            "not-allowed"

    },

    addButton:

    {

        height:

            36,

        padding:

            "0 16px",

        display:

            "flex",

        alignItems:

            "center",

        gap:

            9,

        border:

            "1px solid " +
            OMNISCAN_BLUE,

        borderRadius:

            4,

        background:

            OMNISCAN_BLUE,

        color:

            "#ffffff",

        fontSize:

            9,

        fontWeight:

            700,

        letterSpacing:

            0.3,

        cursor:

            "pointer"

    },

    addButtonDisabled:

    {

        border:

            "1px solid #ccd5da",

        background:

            "#d9e0e4",

        color:

            "#9aa6ae",

        cursor:

            "not-allowed"

    },

    addArrow:

    {

        fontSize:

            14,

        fontWeight:

            400

    }

};